import { render } from "./kaskoMain.vue?vue&type=template&id=76097c02&scoped=true"
import script from "./kaskoMain.vue?vue&type=script&lang=js"
export * from "./kaskoMain.vue?vue&type=script&lang=js"

import "./kaskoMain.vue?vue&type=style&index=0&id=76097c02&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76097c02"]])

export default __exports__